import {CubicBezier,Utils} from '../finalWidgets.js';

export default class Scroll{

	root = null;
	animation_id = null;
	promise = null;

	constructor( root, params ){
		this.root = root;
		this.params = params;
	}

	availableFor( target ){

		return target.offsetLeft <= ( this.root.scrollWidth - this.root.clientWidth );

	}

	run( from, to ){

		if( this.animation_id ){
			cancelAnimationFrame( this.animation_id );

			this.promise.reject();
			this.promise = null;

			this.animation_id = null;
		}

		let offset_fix = 0;

		if( from.offsetLeft != this.root.scrollLeft ){
			offset_fix = Math.abs(( this.root.scrollLeft - from.offsetLeft ) / (from.offsetLeft - to.offsetLeft) );
		}

		let time_initial = (new Date).getTime() - ( this.params.duration * offset_fix );
		let time_final = this.params.duration + time_initial;

		let offset_initial = from.offsetLeft;
		let offset_final = to.offsetLeft;

		if( offset_final === this.root.scrollLeft ){
			this.promise = null;
			return Promise.resolve(to)
		}


		let offset_max = this.root.scrollWidth - this.root.clientWidth;

		// NB: `curve_override` is an ugly hack atm
		let curve = (
			offset_fix
			? null
			: new CubicBezier(
				[0,0],
				[this.params.timing[0], this.params.timing[1] ],
				[this.params.timing[2], this.params.timing[3] ],
				[1,1]
			)
		);

		let frame = () => {

			let time_current = (new Date).getTime();
			if( time_current > time_final ){
				this.root.scrollLeft = offset_final;
				this.promise.resolve( to );
				this.promise = null;
				this.animation_id = null;
				return;
			}

			let time_delta = (time_current - time_initial) / this.params.duration;
			let offset_ratio = (
				curve
				? (curve.coords( time_delta )).y
				: time_delta
			)

			// We need Y here
			let offset = (offset_final - offset_initial) * offset_ratio;
			let value = Utils.clamp(offset_initial + offset, 0, offset_max);
			this.root.scrollLeft = value;

			this.animation_id = requestAnimationFrame(frame)

		}
		this.animation_id = requestAnimationFrame(frame);

		return new Promise((resolve,reject) => {
			this.promise = { resolve, reject }
		});

	}

	initial_scroll = null;

	handlePointerEmployment( e ){

		if( this.animation_id ){
			cancelAnimationFrame( this.animation_id );
			this.promise.reject();
			this.promise = null;
			this.animation_id = null;
		}
	}

	handlePointerMove( initial, current ){

		if( this.animation_id ){
			cancelAnimationFrame( this.animation_id );
			this.promise.reject();
			this.promise = null;
			this.animation_id = null;
		}

		if( this.initial_scroll === null )
			this.initial_scroll = this.root.scrollLeft;

		let delta = -1 * (current.x - initial.x);

		let value = Utils.clamp(this.initial_scroll + delta, 0, this.root.scrollWidth - this.root.clientWidth);

		this.root.scrollLeft = value;
	}

	handlePointerRelease( e ){

		// No actual scrolling occured
		if( this.initial_scroll == this.root.scrollLeft )
			return;

		// Getting current slide
		let target = null;
		let current = null;
		for( let el of [... this.root.children] ){

			if( current && el.offsetLeft > this.root.scrollLeft )
				break;

			current = el;

		}

		let prev = current;
		// Scrolled back
		if( this.initial_scroll > this.root.scrollLeft ){

			prev = current.nextElementSibling;
			target = current;
			
		}
		// Scrolled forward
		else if( this.initial_scroll < this.root.scrollLeft ){

			// Cadidates
			let candidates = [ current.nextElementSibling, current, current.previousElementSibling ];
			for( let candidate of candidates ){
				if( candidate && this.availableFor( candidate ) ){
					target = candidate;
					break;
				}
			}
		}

		this.initial_scroll = null;
		return this.run( prev, target );

	}

}
